// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type QuickCartQueryVariables = Types.Exact<{
  id: Types.CartRequestAction;
}>;


export type QuickCartQuery = { __typename?: 'Query', getCart: { __typename?: 'Cart', id: string, cartIdAlias?: string | null, count: number, cartType?: string | null, customerServiceInstructions?: string | null, packingSlipNote?: string | null, salesOrderSource?: Types.SalesOrderSource | null, contractNumber?: string | null, selectedPaymentMethod?: string | null, displaySaveCartButton: boolean, isEmproveProductExists: boolean, items: Array<{ __typename?: 'CartItem', id: string, quantity: number, brand?: string | null, quoteItemNumber?: string | null, quoteNumber?: string | null, promoCode?: string | null, productNote?: string | null, yourReference?: string | null, type: Types.CartItemType, displayEditButton: boolean, redirectLinkForEdit?: string | null, configurationId?: string | null, productType?: string | null, isSingleLotSelected?: boolean | null, deviceSerialNumber?: Array<string | null> | null, requestedDeliveryDate?: string | null, subscriptionFrequency?: string | null, material: { __typename?: 'Material', id: string, description?: string | null, displaySellerName?: string | null, erpType?: Array<string | null> | null, productKey?: string | null, product: string, name?: string | null, number: string, brand: { __typename?: 'Brand', key: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', mediumUrl: string } | null }, image: { __typename?: 'CatalogImage', smallUrl: string, mediumUrl: string, largeUrl: string } }, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null, sapCharc?: string | null }>, emproveDossierInfo?: { __typename?: 'EmproveDossierItem', dossierId?: string | null, dossierSubType?: string | null, dossierSubLength?: number | null, dossierMaterialNumber?: string | null } | null }>, partners: { __typename?: 'CartPartners', SalesOrg?: string | null, billTo?: string | null, contact?: string | null, payer?: string | null, shipTo?: string | null, soldTo?: string | null, zzPartner?: string | null, znPartner?: string | null } } };

export type QuickCartFragment = { __typename?: 'Cart', id: string, cartIdAlias?: string | null, count: number, cartType?: string | null, customerServiceInstructions?: string | null, packingSlipNote?: string | null, salesOrderSource?: Types.SalesOrderSource | null, contractNumber?: string | null, selectedPaymentMethod?: string | null, displaySaveCartButton: boolean, isEmproveProductExists: boolean, items: Array<{ __typename?: 'CartItem', id: string, quantity: number, brand?: string | null, quoteItemNumber?: string | null, quoteNumber?: string | null, promoCode?: string | null, productNote?: string | null, yourReference?: string | null, type: Types.CartItemType, displayEditButton: boolean, redirectLinkForEdit?: string | null, configurationId?: string | null, productType?: string | null, isSingleLotSelected?: boolean | null, deviceSerialNumber?: Array<string | null> | null, requestedDeliveryDate?: string | null, subscriptionFrequency?: string | null, material: { __typename?: 'Material', id: string, description?: string | null, displaySellerName?: string | null, erpType?: Array<string | null> | null, productKey?: string | null, product: string, name?: string | null, number: string, brand: { __typename?: 'Brand', key: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', mediumUrl: string } | null }, image: { __typename?: 'CatalogImage', smallUrl: string, mediumUrl: string, largeUrl: string } }, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null, sapCharc?: string | null }>, emproveDossierInfo?: { __typename?: 'EmproveDossierItem', dossierId?: string | null, dossierSubType?: string | null, dossierSubLength?: number | null, dossierMaterialNumber?: string | null } | null }>, partners: { __typename?: 'CartPartners', SalesOrg?: string | null, billTo?: string | null, contact?: string | null, payer?: string | null, shipTo?: string | null, soldTo?: string | null, zzPartner?: string | null, znPartner?: string | null } };

export type QuickCartPartnersFragment = { __typename?: 'CartPartners', SalesOrg?: string | null, billTo?: string | null, contact?: string | null, payer?: string | null, shipTo?: string | null, soldTo?: string | null, zzPartner?: string | null, znPartner?: string | null };

export type QuickCartItemFragment = { __typename?: 'CartItem', id: string, quantity: number, brand?: string | null, quoteItemNumber?: string | null, quoteNumber?: string | null, promoCode?: string | null, productNote?: string | null, yourReference?: string | null, type: Types.CartItemType, displayEditButton: boolean, redirectLinkForEdit?: string | null, configurationId?: string | null, productType?: string | null, isSingleLotSelected?: boolean | null, deviceSerialNumber?: Array<string | null> | null, requestedDeliveryDate?: string | null, subscriptionFrequency?: string | null, material: { __typename?: 'Material', id: string, description?: string | null, displaySellerName?: string | null, erpType?: Array<string | null> | null, productKey?: string | null, product: string, name?: string | null, number: string, brand: { __typename?: 'Brand', key: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', mediumUrl: string } | null }, image: { __typename?: 'CatalogImage', smallUrl: string, mediumUrl: string, largeUrl: string } }, configuration: Array<{ __typename?: 'ProductConfiguration', name?: string | null, value?: string | null, sapCharc?: string | null }>, emproveDossierInfo?: { __typename?: 'EmproveDossierItem', dossierId?: string | null, dossierSubType?: string | null, dossierSubLength?: number | null, dossierMaterialNumber?: string | null } | null };

export const QuickCartItemFragmentDoc = gql`
    fragment QuickCartItem on CartItem {
  id
  quantity
  brand
  material {
    id
    description
    displaySellerName
    erpType
    brand {
      key
      name
      color
      logo {
        mediumUrl
      }
    }
    productKey
    product
    image {
      smallUrl
      mediumUrl
      largeUrl
    }
    name
    number
  }
  quoteItemNumber
  quoteNumber
  promoCode
  productNote
  yourReference
  type
  displayEditButton
  redirectLinkForEdit
  configurationId
  configuration {
    name
    value
    sapCharc
  }
  productType
  emproveDossierInfo {
    dossierId
    dossierSubType
    dossierSubLength
    dossierMaterialNumber
  }
  isSingleLotSelected
  deviceSerialNumber
  requestedDeliveryDate
  subscriptionFrequency
}
    `;
export const QuickCartPartnersFragmentDoc = gql`
    fragment QuickCartPartners on CartPartners {
  SalesOrg
  billTo
  contact
  payer
  shipTo
  soldTo
  zzPartner
  znPartner
}
    `;
export const QuickCartFragmentDoc = gql`
    fragment QuickCart on Cart {
  id
  cartIdAlias
  count
  cartType
  items {
    ...QuickCartItem
  }
  customerServiceInstructions
  packingSlipNote
  partners {
    ...QuickCartPartners
  }
  salesOrderSource
  contractNumber
  selectedPaymentMethod
  displaySaveCartButton
  isEmproveProductExists
}
    ${QuickCartItemFragmentDoc}
${QuickCartPartnersFragmentDoc}`;
export const QuickCartDocument = gql`
    query QuickCart($id: CartRequestAction!) {
  getCart(id: $id) {
    ...QuickCart
  }
}
    ${QuickCartFragmentDoc}`;
export type QuickCartComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QuickCartQuery, QuickCartQueryVariables>, 'query'> & ({ variables: QuickCartQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QuickCartComponent = (props: QuickCartComponentProps) => (
      <ApolloReactComponents.Query<QuickCartQuery, QuickCartQueryVariables> query={QuickCartDocument} {...props} />
    );
    

/**
 * __useQuickCartQuery__
 *
 * To run a query within a React component, call `useQuickCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuickCartQuery(baseOptions: Apollo.QueryHookOptions<QuickCartQuery, QuickCartQueryVariables> & ({ variables: QuickCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickCartQuery, QuickCartQueryVariables>(QuickCartDocument, options);
      }
export function useQuickCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickCartQuery, QuickCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickCartQuery, QuickCartQueryVariables>(QuickCartDocument, options);
        }
export function useQuickCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickCartQuery, QuickCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickCartQuery, QuickCartQueryVariables>(QuickCartDocument, options);
        }
export type QuickCartQueryHookResult = ReturnType<typeof useQuickCartQuery>;
export type QuickCartLazyQueryHookResult = ReturnType<typeof useQuickCartLazyQuery>;
export type QuickCartSuspenseQueryHookResult = ReturnType<typeof useQuickCartSuspenseQuery>;
export type QuickCartQueryResult = Apollo.QueryResult<QuickCartQuery, QuickCartQueryVariables>;